import { useGetTaxCategoriesQuery } from '../../api/taxCategory/taxCategoryApiSlice';

/**
 * The tax category a new offering or add-on is prefilled with (#2959), or ''
 * — the picker's "unassigned" — while the catalogue loads or when the tenant
 * has no usable default. Callers use it for NEW rows only; an existing
 * assignment is never replaced with it, and pricing never falls back to it.
 */
export const useDefaultTaxCategoryId = (): string =>
    useGetTaxCategoriesQuery().data?.defaultTaxCategoryId ?? '';
